import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewEducationCategory,
  fetchEditEducationCategory,
  fetchEducationCategoryList,
} from "../actions/educationCategory";
import { useNavigate, useParams } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import EditIcon from "@mui/icons-material/Edit";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { fetchEducationCategoryAllList } from "../actions/educationCategory";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const EducationCategoryAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "educationCategoriesForm";
  const translateModule = "educationCategories";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    countryId: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { educationCategoryDetail, educationCategoryAllList } = useSelector(
    (state) => state.educationCategoryReducer
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setData((prevState) => ({
      ...prevState,
      [name]: value === "" ? "" : value,
    }));
  };

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
    }
  }, [countryFormList]);

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, []);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchEducationCategoryList(id));
    }
    dispatch(fetchEducationCategoryAllList(0));
  }, [id, dispatch]);

  useEffect(() => {
    if (educationCategoryDetail && id) {
      setData({
        ...data,
        name: educationCategoryDetail.name || initialState.name,
        countryId: educationCategoryDetail.countryId || initialState.countryId,
        status: educationCategoryDetail.status || initialState.status,
        createdAt: educationCategoryDetail.createdAt || "",
        updatedAt: educationCategoryDetail.updatedAt || "",
      });
    }
  }, [educationCategoryDetail, id]);

  const clientValidationHandler = () => {
    const { name, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    if (data.parentId == 0) {
      data.parentId = "";
    }

    if (id) {
      data.id = id;
      dispatch(fetchEditEducationCategory(data, navigate));
    } else {
      dispatch(createNewEducationCategory(data, navigate));
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={educationCategoryDetail && educationCategoryDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="product-holder-admin-left-side-text">
                        <Row>
                          <Col lg={8} md={12} xs={12} className="mb-3">
                            <InputField
                              label="Naziv kategorije proizvoda"
                              name="name"
                              value={data.name}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <FormControl
                              fullWidth
                              size="small"
                              required
                              error={errors?.countryId}
                              disabled={countryFormList?.length == 1}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Država
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.countryId}
                                label="Država"
                                name="countryId"
                                onChange={handleInputChange}
                                size="small"
                              >
                                {countryFormList?.map((item, key) => (
                                  <MenuItem value={item.id} key={key}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors?.countryId && (
                                <FormHelperText>obavezno polje</FormHelperText>
                              )}
                            </FormControl>
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default EducationCategoryAdd;
